var map = {
	"./avatar.png": 3534,
	"./chair.png": 7497,
	"./chair16.png": 4939,
	"./chair2.png": 6127,
	"./chair20.png": 9677,
	"./chair3.png": 2842,
	"./chair4.png": 4231,
	"./guest.png": 8304,
	"./guest2.png": 1201,
	"./guestHighlighted.png": 2872,
	"./plus.png": 6664,
	"./plus2.png": 6629
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1221;